<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <div class="filter__name">月份：</div>
        <el-select class="filter__input" size="mini" v-model="filters.month">
          <el-option :label="item.name" :value="item.month" v-for="(item, index) in monthLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <button class="blue-small-btn" @click="download()">导出数据</button>
        <button class="blue-small-btn ml-20" @click="downloadAdDetail()">导出详细数据</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700" :summary-method="getSummaries" show-summary>
      <el-table-column prop="adid" label="广告ID" width="" align="center" sortable>
        <template slot-scope="scope">
          <router-link :to="{path: '/adOrder', query: {adid: scope.row.adid}}" target='_blank'>{{scope.row.adid}}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="广告名" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="下载对账数据" width="" align="center">
        <template slot-scope="scope">
         <el-button type="primary" icon="el-icon-download" size="mini" class="copy-btn" @click="downloadAd(scope.row.adid)"></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="" label="状态" width="" align="center" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1" class="normal-btn">运行</div>
          <div v-if="scope.row.status == 0" class="danger-btn">下架</div>
        </template>
      </el-table-column>
      <el-table-column prop="purchases" label="购买类型" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="min_discount" label="底价折扣" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.min_discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="quota" label="总额度" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="ocount" label="订单数" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="payment" label="金额" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="income" label="收入" width="" align="center">
      </el-table-column>
      <el-table-column prop="commission" label="佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="profit" label="利润" width="" align="center" sortable>
       <template slot-scope="scope">
          <div v-if="scope.row.profit < 0" class="fc-red pointer">
            {{scope.row.profit}}
          </div>
          <div v-else> {{scope.row.profit}} </div>
        </template>
      </el-table-column>
      <el-table-column prop="estimate_profit" label="预估利润" width="" align="center">
       <template slot-scope="scope">
          <div v-if="scope.row.estimate_profit < 0" class="fc-red pointer">
            {{scope.row.estimate_profit}}
          </div>
          <div v-else> {{scope.row.estimate_profit}} </div>
        </template>
      </el-table-column>
      <el-table-column prop="apply" label="请款" width="" align="center">
      </el-table-column>
      <el-table-column prop="receive" label="收款" width="" align="center">
      </el-table-column>
      <el-table-column prop="agency_fees" label="拍收费" width="" align="center">
      </el-table-column>
      <el-table-column prop="express_fees" label="快递费" width="" align="center">
      </el-table-column>
    </el-table>
  </article>
</template>
<script>
import {operLists, dsMonthSummary, downloadDsMonthSummary, downloadAdOrderLists, downloadDsAdDetail} from '../../api/api'
import util from '../../script/util'
export default {
  name: 'dsMonthSummary',
  data () {
    return {
      filters: {
        opid: '',
        month: ''
      },
      lists: [],
      listLoading: false,
      operLists: [],
      monthLists: []
    }
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!['adid', 'title', 'min_discount', 'quota'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    getMonthLists () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1

      // this.monthLists = [{name: '月份', month: ''}]
      for (let i = 0; i < 12; i++) {
        let monthStr = (month > 9) ? month.toString() : ('0' + month)
        let yearMonth = year.toString() + '-' + monthStr

        this.monthLists.push({'name': yearMonth, 'month': yearMonth})
        if (month === 1) {
          year = year - 1
          month = 12
        } else {
          month = month - 1
        }
      }
      this.filters.month = this.monthLists[0].month
    },
    getOperLists () {
      let params = {
        l: 100,
        p: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.operLists = data.d.lists.map((item, index) => {
            return {
              nickname: item.nickname,
              opid: item.opid
            }
          })
          this.operLists.unshift({
            nickname: '所有',
            opid: ''
          })
        }
      })
    },
    downloadAd (adid) {
      let link = downloadAdOrderLists + '?choose=' + 4
      link = link + '&adid=' + adid
      window.open(link, 'a')
    },
    download () {
      let filters = this.filters
      let link = downloadDsMonthSummary + '?download=1'

      link = link + '&month=' + filters.month

      window.open(link, 'a')
    },
    downloadAdDetail () {
      let filters = this.filters
      let link = downloadDsAdDetail + '?month=' + filters.month

      window.open(link, 'a')
    },
    getList () {
      let params = {
        month: this.filters.month
      }

      this.listLoading = true
      dsMonthSummary(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.getMonthLists()
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.month': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/data/adDsMonthSummary.vue